module.exports = new __parcel__URL__("oncall-preview.83fb7508.svg").toString();